import { render } from "./RoleFormModal.vue?vue&type=template&id=48e31fe6&scoped=true"
import script from "./RoleFormModal.vue?vue&type=script&lang=js"
export * from "./RoleFormModal.vue?vue&type=script&lang=js"

import "./RoleFormModal.vue?vue&type=style&index=0&id=48e31fe6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48e31fe6"]])

export default __exports__